import { ApiUrl } from "../../../assets/data/TkApiUrlProperty";
import http from "../../../services/http";
import {
  IAPI_STA003_Request,
  IAPI_STA003_Response,
} from "../../../type/apiType";

import {
  IAPI_APP016_Request,
  IAPI_APP016_Response,
} from "../../../type/apiType";

// 退職者情報詳細参照
const httpAPI_STA003 = async (
  param: IAPI_STA003_Request
): Promise<IAPI_STA003_Response> => {
  let res = await http.post(ApiUrl.API_STA003, {
    ...param,
  });

  return res.data;
};

// 申請状況更新API
// API仕様書_申請情報_申請状況更新
const httpAPI_APP016 = async (
  param: IAPI_APP016_Request
): Promise<IAPI_APP016_Response> => {
  let res = await http.post(ApiUrl.API_APP016, {
    ...param,
  });

  return res.data;
};

export { httpAPI_STA003, httpAPI_APP016 };
